"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("circle", {
      cx: "20",
      cy: "20",
      r: "19.5",
      stroke: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      opacity: "0.2",
      d: "M20 39.5C17.53 39.5 15.1592 37.4847 13.3761 33.9185C11.608 30.3823 10.5 25.4621 10.5 20C10.5 14.5379 11.608 9.6177 13.3761 6.08147C15.1592 2.51533 17.53 0.499999 20 0.5C22.47 0.5 24.8408 2.51534 26.6239 6.08147C28.392 9.6177 29.5 14.5379 29.5 20C29.5 25.4621 28.392 30.3823 26.6239 33.9185C24.8408 37.4847 22.47 39.5 20 39.5Z",
      stroke: "currentColor"
    })]
  });
};

exports.default = Icon;